import Head from 'next/head'
import { getImagesURLFromString } from '../util/imageOptimizationUtils'

export type OptimizedImagesProps = {
    optimizeBlockImages: {
        images: string[]
        quality?: number
        imageFormat?: string
        auto?: string
    }
}

export const PreloadImages = ({
    optimizeBlockImages: {
        images,
        quality = 70,
        imageFormat = 'pjpg',
        auto = 'webp'
    }
}: OptimizedImagesProps): JSX.Element | null => {
    const imageURLS = []

    if (!images.length) return null

    for (const image of images) {
        imageURLS.push(...getImagesURLFromString(image))
    }

    return (
        <Head>
            {imageURLS?.map((url) => {
                const optimizeURLParams = `?quality=${quality}&auto=${auto}&format=${imageFormat}`
                return (
                    <link
                        key={url}
                        rel="preload"
                        as="image"
                        href={url.concat(optimizeURLParams)}
                        type="image/png"
                    />
                )
            })}
        </Head>
    )
}
